import router from "../router";
import axios from "axios";
import lscache from "lscache";
import md5 from "md5";
import store from "../store";

export class BaseApiClient {
  // instance;
  constructor(appApi = process.env.VUE_APP_API_URL) {
    this.instance = axios.create({
      baseURL: appApi,
    });
    lscache.flush();
  }

  call(action, method, data, fromCache) {
    fromCache = fromCache === true ? true : false;

    let url =
      process.env.VUE_APP_API_URL + (action[0] === "/" ? "" : "/") + action;
    let keyCache = null;

    let request = {
      method: method,
      url: action,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    if (method === "GET") {
      request.params = data;
      keyCache = md5(url + JSON.stringify(data));
    } else {
      request.data = data;
    }

    return new Promise((resolve, reject) => {
      if (fromCache === true && keyCache && lscache.get(keyCache)) {
        resolve(lscache.get(keyCache));
      } else {
        this.instance
          .request(request)
          .then((result) => {
            if (fromCache === true && keyCache) {
              lscache.set(keyCache, result, 5);
            }
            resolve(result);
          })
          .catch((error) => {
            if (
              error &&
              error.response &&
              [401].indexOf(error.response.status) != -1
            ) {
              const result = this.refreshToken();
              result
                .then((res) => {
                  store.commit("setStorage", res.data);
                })
                .finally(() => {
                  this.call(action, method, data, fromCache)
                    .then((res) => {
                      if (fromCache === true && keyCache) {
                        lscache.set(keyCache, result, 5);
                      }
                      resolve(res);
                    })
                    .catch((err) => {
                      reject(error);
                    });
                });
              return;
            } else {
              reject(error);
            }
          });
      }
    });
  }

  refreshToken() {
    let url = process.env.VUE_APP_API_URL + "/auth/refresh";

    let request = {
      method: "POST",
      url,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    return new Promise((resolve, reject) => {
      this.instance
        .request(request)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          if (error && error.response) {
            window.location = "/compliance/login";
            return;
          }
          reject(error);
        });
    });
  }

  directUploadFile(file, inputs, ref, extraParams = null) {
    inputs = inputs || false;
    return new Promise((resolve, reject) => {
      this.getLgpdFilesPreSignedUrl({
        inputs: inputs,
        file_name: file.name.trim(),
        ...extraParams,
      })
        .then((res) => {
          var form = new FormData();
          for (let key in res.data.inputs) {
            form.set(key, res.data.inputs[key]);
          }
          form.set("Content-Type", file.type);
          form.set("file", file);

          this.instance
            .request({
              method: "post",
              url: res.data.url,
              data: form,
              headers: { "Content-Type": "multipart/form-data" },
              onUploadProgress: (progressEvent) => {
                if (ref)
                  ref.progress = parseInt(
                    Math.round(
                      (progressEvent.loaded / progressEvent.total) * 100
                    )
                  );
              },
            })
            .then(() => {
              this.postFilesPreSignedUrl({
                name: file.name,
                key: res.data.inputs.key,
                ...extraParams,
              })
                .then((resfile) => {
                  resolve(resfile.data);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
